import { useUIColors } from '@/core/hooks';
import SearchSvg from '@assets/images/svg/search.svg';
import React from 'react';
import { View } from 'react-native';

export interface SearchIconProps {
    size?: number;
    color?: string;
}

export const SearchIcon = React.memo<SearchIconProps>(function SearchIcon({
    size = 19,
    color = '#666666',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <SearchSvg width={size} height={size} color={color} />
        </View>
    );
});

export default SearchIcon;
